import api from "./api";

class AziendaManager {

    aziende(config?: any) {
        return api.get(`/aziende`, config)
    }

    azienda(aziende_id: number | string | undefined, config?: any) {
        return api.get(`/aziende/${aziende_id}`, config)
    }

    retrieve = this.azienda
    list = this.aziende
}

const aziendeManager = new AziendaManager()

export default aziendeManager
